// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"21":"MobileFiltersModal","175":"LazyWUTComponents","856":"LazyProductQuickAdd"}[chunkId] || chunkId) + ".chunk.min.js";
};